import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ensureQQPixelLoaded, trackQQPageView } from '../utils/qqPixel';

/**
 * Loads Meta Pixel only when mounted.
 * Intended to be rendered only on the `/qq/*` route.
 */
export default function QQPixelAnalytics() {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.startsWith('/qq')) return;
    ensureQQPixelLoaded();
  }, [location.pathname]);

  // Track SPA navigations for /qq/*.
  useEffect(() => {
    if (!location.pathname.startsWith('/qq')) return;
    trackQQPageView();
  }, [location.pathname, location.search]);

  return null;
}
